import { getPaymentsMdaCount } from "common/services/payments.service";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

const TotalMDAsWidget = ({ activeTab }: any) => {
  const [totalMDAs, setTotalMDAs] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsMdaCount({
          startDate: "2017-01-01",
          endDate: `${new Date().getFullYear()}-12-31`,
        });

        setTotalMDAs(response?.mdaCount);
      } catch (error) {
        console.warn("Error fetching total  support", error);
      }
    };

    fetchData();
  }, [activeTab]);

  return (
    <div className="p-3 border border-dashed border-end-0">
      <h5 className="mb-1">
        <span className="counter-value" data-target={totalMDAs}>
          <CountUp
            start={0}
            end={totalMDAs}
            decimals={0}
            suffix={""}
            duration={1}
          />
        </span>
      </h5>
      <p className="text-muted mb-0">MDAs</p>
    </div>
  );
};

export default TotalMDAsWidget;
